// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"products_wrapper__5xaMj","header":"products_header__lJ0Jo"};